import PropTypes from 'prop-types';

import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';
import { ClassNameDefaultProps } from '@/common/proptypes/Base/ClassName.protypes';
import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';

export const CategoriesDefaultProps = {
  ...ClassNameDefaultProps,
  ...DisabledDefaultProps,
  ...ChildrenDefaultProps,
  name: null,
  onChange: () => {},
  title: null,
  wishlists: [],
};

export const CategoriesPropTypes = {
  ...DisabledPropTypes,
  ...DisabledPropTypes,
  ...ChildrenPropTypes,
  name: PropTypes.string,
  onChange: PropTypes.func,
  title: PropTypes.string,
  wishlists: PropTypes.arrayOf(
    PropTypes.shape({
      item_count: PropTypes.number,
    }),
  ),
};
